import React, { Component } from 'react';
import Head from 'next/head';
import Router from 'next/router';
import LayoutContainer from 'components/layout/LayoutContainer';
import { Breadcrumbs, SpinnerV } from 'components/widgets';

import DOMPurify from 'isomorphic-dompurify';

const sanitizer = DOMPurify.sanitize;

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'store/actions';

class PrivacyPolicyPage extends Component {
	state = {
		routes: [
			{
				name: 'Inicio',
				pathname: '/',
				asPath: '/'
			},
			{
				name: 'Política de privacidad',
				pathname: Router?.router?.pathname,
				asPath: Router?.router?.asPath
			}
		],
		content: '',
		spinnerScreen: false
	};

	componentDidMount() {
		this.setState({ spinnerScreen: true }, async () => {
			let res = await this.props.actions.getLegalDocument(
				'politica-privacidad'
			);
			this.setState({ ...res });
		});
	}

	render() {
		const isMobile = Router.router?.asPath === '/m/politica-privacidad';

		return (
			<LayoutContainer
				ocult={
					isMobile
						? true
						: this.props.ocult
				}
			>
				{this.state.spinnerScreen && <SpinnerV />}

				{Router.router?.asPath === '/politica-privacidad' && (
					<div className="mt-24">
						<Breadcrumbs routes={this.state.routes} />
					</div>
				)}
				<div
					className={this.props.isDialog !== true ? 'container pb-12 pt-4' : ''}
				>
					<Head>
						<meta name="robots" content="noindex" />
					</Head>
					<div
						dangerouslySetInnerHTML={{ __html: sanitizer(this.state.content) }}
					></div>
				</div>
			</LayoutContainer>
		);
	}
}

const mapDispatchToProps = (dispatch) => ({
	actions: bindActionCreators(actions, dispatch)
});

export default connect(null, mapDispatchToProps)(PrivacyPolicyPage);
